import React from 'react';

import Section from './Section';
import SectionHero from './SectionHero';

const Breakpoint = (props) => {
  return (
    <Section colour={props.colour || 'dark'} size="small">
      <SectionHero noHr {...props} />
    </Section>
  );
};

const CustomBreakpoint = ({
  breakpointTheme,
  header,
  description,
  ctaTheme,
  primaryCta,
  link,
  secondaryCta,
  link2,
}) => {
  const props = {
    title: header,
    description,
    colour: breakpointTheme,
    ctas: [
      ...(primaryCta
        ? [
            {
              label: primaryCta,
              href: link,
              colour: ctaTheme,
              appearance: 'regular',
            },
          ]
        : []),
      ...(secondaryCta
        ? [
            {
              label: secondaryCta,
              href: link2,
              colour: ctaTheme,
              appearance: 'outline',
            },
          ]
        : []),
    ],
  };
  return <Breakpoint {...props} />;
};

const SalesBreakpoint = () => {
  const props = {
    title: "It's easy to get started",
    description:
      'GraphCMS plans are flexibly suited to accommodate your growth. Get started for free, or reach out to our sales team to discuss larger projects with more complex needs',

    ctas: [
      {
        label: 'Sign up for free',
        href: 'https://app.graphcms.com/signup/',
        appearance: 'outline',
      },
      { label: 'Contact sales', href: '/contact' },
    ],
  };

  return <Breakpoint {...props} />;
};

const SignupBreakpoint = () => {
  const props = {
    title: 'Start for free, and scale as you go',
    description:
      'Get started in minutes with the fully hosted GraphQL Headless CMS. No credit card or upfront commitments required',
    ctas: [
      {
        label: 'Sign up for free',
        href: 'https://app.graphcms.com/signup/',
      },
    ],
  };

  return <Breakpoint {...props} />;
};

export { CustomBreakpoint, SalesBreakpoint, SignupBreakpoint };
